// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9a5d058e","881":"6634a64b"}[chunkId] + ".chunk.js";
};